/**
 * 处方类型枚举
 */
export enum EPrescriptionType {
  /** 单光镜 */
  SINGLE_VISION = 'Single Vision',

  /** 渐进镜 */
  PROGRESSIVE = 'Progressive',

  /** 无处方太阳镜 */
  SUNGLASSES_NON_PRESCRIPTION = 'Sunglasses Non-Prescription',

  /** 老花镜 */
  READING_GLASSES = 'Reading Glasses',

  /** 处方太阳镜 */
  SUNGLASSES_PRESCRIPTION = 'Sunglasses Prescription',

  /** 无处方 */
  NON_PRESCRIPTION = 'Non-Prescription',

  /** Frame Only */
  FRAME_ONLY = 'Frame Only',

  /** Transitionsr 全视线 */
  TRANSITIONSR = 'Transitionsr',

  /** 成品老花镜 */
  READERS = 'Readers',

  /** 处方老花镜 */
  PRESCRIPTION_READING = 'Prescription Reading',
}

/**
 * 镜片类型枚举
 */
export enum ELensType {
  /** 标准眼镜镜片 */
  STANDARD_EYEGLASS_LENSES = 'Standard Eyeglass Lenses',

  /** 染色片 */
  COLOR_TINT = 'Color Tint',

  /** 渐进镜片 */
  PROGRESSIVE = 'Progressive',

  /** 防蓝光 */
  BLUE_LIGHT_BLOCKING = 'Blue Light Blocking',

  /** 偏光太阳镜镜片 */
  POLARIZED_SUNGLASS_LENSES = 'Polarized Sunglass Lenses',

  /** 渐进式防蓝光 */
  PROGRESSIVE_BLUE_LIGHT_BLOCKING = 'Progressive Blue Light Blocking',

  /** 光致变色镜片 */
  PHOTOCHROMIC_LENSES = 'Photochromic Lenses',

  // 光之渐变
  PHOTOCHROMIC = 'Photochromic',

  /** 镜面镜片 */
  MIRRORED_LENSES = 'Mirrored Lenses',

  /** 光致变色渐进镜 */
  PHOTOCHROMIC_PROGRESSIVE = 'Photochromic Progressive',

  /** 光致变色蓝光阻隔镜片 */
  PHOTOCHROMIC_BLUE_LIGHT_BLOCKING = 'Photochromic Blue Light Blocking',

  /** 驾驶镜片 */
  DRIVING_LENSES = 'Driving Lenses',

  /** Frame Only */
  FRAME_ONLY = 'Frame Only',

  UV_PROTECTION = 'UV Protection',
  ANTI_SCRATCH_COATING = 'Anti-Scratch Coating',
}

/**
 * 商品状态枚举
 */
export enum EGoodsStatus {
  /** 可购买 */
  BUY_NOW = 'Buy Now',

  /** 售罄 */
  SOLD_OUT = 'SOLD OUT',

  /** 不再补货 */
  NO_RESTOCK = 'No Restock',
}

/**
 * 商品促销标签枚举
 */
export enum EGoodsSaleLabel {
  /** 新品到货 */
  NEW_IN = 'NEW IN',

  /** 闪购 */
  FLASH_SALE = 'FLASH SALE',

  /** 秒杀 */
  SECKILL = 'Seckill',
}

export enum EProductImageType {
  /** 商品主图 */
  PRODUCT = 1,
  /** 模特图 */
  CELEBRITY,
  /** 素材图 */
  MATERIAL,
}

/**
 * 商品标签类型枚举
 */
export enum EProductItemTagType {
  'Package Set' = 3,
  'Gift' = 4,
  'Redeemed' = 5,
  'Seckill' = 6,
  '' = 7,
  'Extra Gift' = 'extra',
  'Exclusive Item' = 'member_only',
}

export const enum ELensColor {
  NON = 'non',
}
export const enum EFrameLeg {
  SPRING_LEG = '弹簧腿',
  SLINGSHOT = '弹弓',
}
